var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"mt-3",attrs:{"flat":"","dense":"","item-key":"id","disableSort":"","items-per-page":-1,"headers":_vm.headers,"items":_vm.students,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.index",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("ordinalNumber")(item,_vm.students))+"\n  ")]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor(item.status),"dark":""}},[_vm._v(_vm._s(item.status))])]}},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('user-item',{attrs:{"student":item,"link":""}})]}},{key:"item.dob",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("ddmmyyyy")(item.dob)))]}}],null,true),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }